(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["withdrawal-form"]) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-withdrawal]').forEach((root) => {
        if (root.dataset.withdrawalReady) return;
        const form = root.querySelector('form');
        const result = root.querySelector('[data-withdrawal-result]');
        if (result) result.focus();
        const details = root.querySelector('[data-withdrawal-details]');
        if (!form || !details) return;
        const review = root.querySelector('[data-withdrawal-review]');
        const next = root.querySelector('[data-withdrawal-next]');
        const back = root.querySelector('[data-withdrawal-back]');
        const showDetails = () => {
          details.hidden = false;
          review.hidden = true;
        };
        const showReview = () => {
          if (!form.reportValidity()) return;
          root.querySelectorAll('[data-withdrawal-summary]').forEach((output) => {
            const field = root.querySelector('[data-withdrawal-field="' + output.dataset.withdrawalSummary + '"]');
            output.textContent = field.value.trim() || output.dataset.withdrawalEmpty || '';
          });
          details.hidden = true;
          review.hidden = false;
          root.querySelector('[data-withdrawal-review-title]').focus();
        };
        next.addEventListener('click', showReview);
        back.addEventListener('click', () => {
          showDetails();
          root.querySelector('[data-withdrawal-details-title]').focus();
        });
        form.addEventListener('invalid', showDetails, true);
        form.addEventListener('submit', (event) => {
          if (review.hidden) {
            event.preventDefault();
            showReview();
          }
        });
        root.querySelector('[data-withdrawal-direct]').hidden = true;
        root.querySelector('[data-withdrawal-step]').hidden = false;
        next.hidden = false;
        root.dataset.withdrawalReady = 'true';
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
